import comp from "./MoreItem";
export default comp;
